import { ExportProgressBarModal } from 'Modals';

const ProgressCircle = {};

ProgressCircle.init = (callback) => {
  // This is the default new account page url pulled from the preview modal.
  const href = document.querySelector('.proceed-to-export-upgrade').getAttribute('href');
  const userId = window.COOKIE.get('userid');

  const defaultCallback = () => {
    window.location.assign(href);
  };
  const callbackToUse = callback || defaultCallback;

  // Don't show export modal if the user is logged in
  // or if the download should be free for SEO purposes
  if (userId || window.location.pathname === '/builder-download.php') {
    callbackToUse();
    return;
  }

  // https://app.optimizely.com/v2/projects/48120048/experiments/11074953455/variations/11053235131
  // Currently we have a split test that overrides this init method. The primary reason for this, is that
  // the split test affects different parts of the page (uses different id's to mount components), which
  // means we cannot use our OptimizelyTestContainer as usual
  ExportProgressBarModal.init('exportProgressBarModalContainer', {
    href,
    callback: callbackToUse,
  });
};

module.exports = ProgressCircle;



// WEBPACK FOOTER //
// ./src-assets/js/progress-circle.js